const OVERLAY = {
    onReady() {
        let anchors = document.querySelectorAll('a');
        anchors.forEach(anchor => {
            if (anchor.href.includes('central.45grad.de/formulare') || anchor.href.includes('central.45grad.de/overlays')) {
                anchor.addEventListener('click', event => {
                    OVERLAY.call(anchor, event);
                });
            }
        });
        OVERLAY.exit();
    },
    close(that) {
        let overlay = that.parentNode;
        overlay.style.display = 'none';
        document.body.classList.remove('noscroll');
        (that.classList.contains('exit-close')) && COOKIE.set({name: 'exit-overlay', value: 'true', days: 1});
    },
    call(anchor, event) {
        event.preventDefault();
        let xhr, responseText;
        (window.XMLHttpRequest) && (xhr = new XMLHttpRequest());
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4 && xhr.status === 200) {
                let html        = xhr.responseText;
                let mainContent = html.match(/(?=<main>).*?(<\/main>)/gs);
                let tempDOM     = document.createElement('html');
                tempDOM.innerHTML = `<html>${mainContent}</html>`;
                let wrapper     = tempDOM.querySelector('.js-wrapper');
                let wrapperId   = wrapper.id;
                let container   = document.getElementById(wrapperId);
                if (container === null) return;
                if (container.classList.contains('js-overlay')) {
                    container.style.display = 'block';
                    container.style.opacity = '1';
                    document.body.classList.add('noscroll');
                } else {
                    container.scrollIntoView({
                        behavior: 'auto',
                        block: 'center',
                        inline: 'center'
                    });
                }
                let form = container.querySelector('form');
                if (form !== null) {
                    TRACKING.formEvents({
                        form: form, 
                        action: 'FORM-AUFRUF'
                    });
                }
                CLEAN.onReady();
            }
        }
        xhr.open('GET', anchor.href, true );
        xhr.send();
    },
    exit() {
        if (window.innerWidth < 960) return;
        const overlay = document.getElementById('exit-overlay');
        if (overlay === null) return;
        document.body.addEventListener('mouseleave', () => {
            if (COOKIE.get({name: 'exit-overlay'})) return;
            overlay.style.display = 'block';
            overlay.style.opacity = '1';
            document.body.classList.add('noscroll');
            CLEAN.onReady();
        });
    },
    loading() {
        let markup = `
        <div class="overlay--loading" id="overlay-loading">
            <div id="loading">
                <div class='overlay--loading__container--loader'>
                    <div class="loader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </div>
        </div>`;
        document.body.insertAdjacentHTML('afterbegin', markup);
    }
}